<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['storageRoom.name']" clearable placeholder="business.label.storageRoomName" @clear="refresh" @dblclick.native="onStorageRoomSelect"/>
        <vxe-input v-model="query['zone.name']" clearable placeholder="business.label.zoneName" @clear="refresh" @dblclick.native="onZoneSelect"/>
        <vxe-input v-model="query['region.no']" clearable placeholder="business.label.region" @clear="refresh" @dblclick.native="onRegionSelect"/>
        <vxe-input v-model="query['no']" clearable placeholder="business.label.locationNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query['locationType']" :options="locationTypes" clearable placeholder="business.label.locationType" @change="refresh()" @clear="refresh"/>
        <vxe-select v-model="query['locationStatus']" :options="locationStatus" clearable placeholder="business.label.locationStatus" @change="refresh()" @clear="refresh"/>
        <vxe-select v-model="query['storageType']" :options="storageTypes" clearable placeholder="business.label.storageType" @change="refresh()" @clear="refresh"/>
        <vxe-select v-model="query['locking']" :options="options" clearable placeholder="business.label.locking" @change="refresh()" @clear="refresh"/>
        <vxe-select v-model="query['mechanicalLocking']" :options="options" clearable placeholder="business.label.mechanicalLocking" @change="refresh()" @clear="refresh"/>
        <vxe-input v-model="query['roadway']" clearable placeholder="business.label.roadway" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['x']" clearable placeholder="business.label.row" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['y']" clearable placeholder="business.label.layer" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['z']" clearable placeholder="business.label.column" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
        <vxe-button content="button.export" icon="vxe-icon-upload" status="info" @click="exportExcel"/>
      </template>
      <vxe-table ref="table" :data="data" :export-config="{}" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" sortable title="business.label.locationNo" width="100"/>
        <vxe-column field="name" title="business.label.locationName" width="100"/>
        <vxe-column field="zone.name" title="business.label.zoneName" width="120"/>
        <vxe-column field="region.name" title="business.label.region" width="100"/>
        <vxe-column :cell-render="{name:'FormatSelect',props:{disabled:true},options:locationTypes}" field="locationType" title="business.label.locationType" width="70"/>
        <vxe-column :cell-render="{name:'FormatSelect',props:{disabled:true},options:locationStatus}" field="locationStatus" title="business.label.locationStatus" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="locking" title="business.label.locking" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="mechanicalLocking" title="business.label.mechanicalLocking" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="containerControl" title="business.label.containerControl" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="automatic" title="business.label.automatic" width="70"/>
        <vxe-column :cell-render="{name:'FormatSelect',props:{disabled:true},options:storageTypes}" field="storageType" title="business.label.storageType" width="70"/>
        <vxe-column :cell-render="{name:'FormatSelect',props:{disabled:true},options:saleClassifications}" field="saleClassification" title="business.label.saleClassification" width="70"/>
        <vxe-column :cell-render="{name:'FormatSelect',props:{disabled:true},options:rackTypes}" field="rackType" title="business.label.rackType" width="70"/>
        <vxe-column :cell-render="{name:'FormatSelect',props:{disabled:true},options:pileupTypes}" field="pileupType" title="business.label.pileupType" width="70"/>
        <vxe-column field="roadway" title="business.label.roadway" width="40"/>
        <vxe-column field="x" title="business.label.row" width="40"/>
        <vxe-column field="y" title="business.label.layer" width="40"/>
        <vxe-column field="z" title="business.label.column" width="40"/>
        <vxe-column field="depth" title="business.label.depth" width="40"/>
        <vxe-column field="dimension.length" title="business.label.length" width="40"/>
        <vxe-column field="dimension.width" title="business.label.width" width="40"/>
        <vxe-column field="dimension.height" title="business.label.height" width="40"/>
        <vxe-column field="dimension.volume" title="business.label.volume" width="60"/>
        <vxe-column field="occupiedCapacity" title="business.label.occupiedCapacity" width="60"/>
        <vxe-column field="shortNo" title="business.label.shortNo" width="70"/>
        <vxe-column field="customer.name" title="business.label.customerName" width="100"/>
        <vxe-column field="wave" title="business.label.wave" width="100"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
            <vxe-button v-if="!row.available" content="button.enable" icon="vxe-icon-unlock" status="success" @click.stop="enable(row,true)"/>
            <vxe-button v-if="row.available" :disabled="row.locationStatus>1" content="button.disable" icon="vxe-icon-lock" status="danger" @click.stop="enable(row,false)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
    <zone-modal ref="zoneModal" :title="'区域检索'" @change="onZoneChange"/>
    <field-modal ref="regionModal" :no="'LOCATION_REGION'" :show-value="false" :title="$t('business.label.region')" @change="onRegionChange"/>
    <location-edit ref="locationEdit" :location-status="locationStatus" :location-types="locationTypes" :pileup-types="pileupTypes" :rack-types="rackTypes" :regions="regions" :sale-classifications="saleClassifications" :storage-types="storageTypes" @success="refresh"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import LocationEdit from './LocationEdit.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import FieldModal from '@/views/modal/FieldModal.vue'
import { getDictionaries, getEnums } from '@/utils/util'

export default {
  name: 'LocationTable',
  components: { FieldModal, LocationEdit, StorageRoomModal, ZoneModal },
  data() {
    return {
      loading: false,
      data: [],
      regions: [],
      locationTypes: [],
      locationStatus: [],
      rackTypes: [],
      storageTypes: [],
      pileupTypes: [],
      saleClassifications: [],
      options: [
        { label: this.$t('business.label.true'), value: true },
        { label: this.$t('business.label.false'), value: false }
      ],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'no': '',
        'zone.name': '',
        'storageRoom.name': '',
        'region.no': '',
        locationType: undefined,
        locationStatus: undefined,
        storageType: undefined,
        roadway: '',
        x: '',
        y: '',
        z: '',
        locking: undefined,
        mechanicalLocking: undefined
      }
    }
  },
  created() {
    getDictionaries('LOCATION_REGION').then(result => {
      this.regions = result
      return getEnums('LocationType')
    }).then(result => {
      this.locationTypes = result
      return getEnums('LocationStatus')
    }).then(result => {
      this.locationStatus = result
      return getEnums('RackType')
    }).then(result => {
      this.rackTypes = result
      return getEnums('StorageType')
    }).then(result => {
      this.storageTypes = result
      return getEnums('PileupType')
    }).then(result => {
      this.pileupTypes = result
      return getEnums('SaleClassification')
    }).then(result => {
      this.saleClassifications = result
    }).finally(() => this.refresh())
  },
  methods: {
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open()
    },
    onStorageRoomChange(sr) {
      if (sr.length > 0) {
        this.query['storageRoom.name'] = sr[0].name
      } else {
        this.query['storageRoom.name'] = ''
      }
      this.query['zone.name'] = ''
      this.refresh()
    },
    onZoneSelect() {
      this.$refs.zoneModal.open({ 'storageRoom.name': this.query['storageRoom.name'] })
    },
    onZoneChange(zone) {
      if (zone.length > 0) {
        this.query['zone.name'] = zone[0].name
      } else {
        this.query['zone.name'] = ''
      }
      this.refresh()
    },
    onRegionSelect() {
      this.$refs.regionModal.open()
    },
    onRegionChange(region) {
      if (region.length > 0) {
        this.query['region.no'] = region[0].no
      } else {
        this.query['region.no'] = ''
      }
      this.refresh()
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('locationFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    add() {
      this.$refs.locationEdit.add()
    },
    edit(record) {
      this.$refs.locationEdit.edit(record)
    },
    enable(record, available) {
      this.$refs.locationEdit.enable(record, available)
    },
    exportExcel() {
      this.$refs.table.openExport()
    },
    reset() {
      this.query['no'] = ''
      this.query['storageRoom.name'] = ''
      this.query['zone.name'] = ''
      this.query['region.no'] = ''
      this.query['locationType'] = undefined
      this.query['locationStatus'] = undefined
      this.query['storageType'] = undefined
      this.query['roadway'] = ''
      this.query['x'] = ''
      this.query['y'] = ''
      this.query['z'] = ''
      this.query['locking'] = undefined
      this.query['mechanicalLocking'] = undefined
      this.page = 1
      this.fetch()
    }
  }
}
</script>